/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCSVRowFromJSON, ApiCSVRowToJSON, } from './ApiCSVRow';
export function ApiCSVTestResultFromJSON(json) {
    return ApiCSVTestResultFromJSONTyped(json, false);
}
export function ApiCSVTestResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorRows': !exists(json, 'errorRows') ? undefined : json['errorRows'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'rows': !exists(json, 'rows') ? undefined : (json['rows'].map(ApiCSVRowFromJSON)),
        'successRows': !exists(json, 'successRows') ? undefined : json['successRows'],
    };
}
export function ApiCSVTestResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorRows': value.errorRows,
        'headers': value.headers,
        'rows': value.rows === undefined ? undefined : (value.rows.map(ApiCSVRowToJSON)),
        'successRows': value.successRows,
    };
}
